import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

export type NotificationDotColor = 'red' | 'yellow';

@Component({
  selector: 'app-notification-dot',
  templateUrl: './notification-dot.component.html',
  styleUrls: ['./notification-dot.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.yellow]': 'color === "yellow"',
    '[style.top]': 'top',
    '[style.right]': 'right',
  },
})
export class NotificationDotComponent {
  @Input({ required: true }) color: NotificationDotColor;
  @Input() top: string = '1px';
  @Input() right: string = '1px';
}
